import { t } from '@/i18n'
import type { ShiftMovement } from '@/types'

import { EmptySeparator, Label, MovementsBreakdown, Section } from './components'

function generateShiftMovements(report: { movements: ShiftMovement[] }, name: string, config: any) {
  return [
    new Label(`${t('movements-report.movements')} ${name}`.toUpperCase(), {
      style: 'bold 24px',
      lineHeight: 30
    }),
    new Label(new Date(), {
      style: '16px',
      lineHeight: 30,
      valueType: 'date'
    }),
    new EmptySeparator(),
    new Label(config.legalEntity.companyName, { style: 'bold 24px', lineHeight: 30 }),
    new Label(config.legalEntity.taxId, { style: '16px', lineHeight: 30 }),
    new Label(config.legalEntity.address, { style: '16px', lineHeight: 30 }),
    new Section(t('card-movements.movements')),
    new MovementsBreakdown(report.movements)
  ]
}

export default generateShiftMovements
